import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { mockData } from '../mock';
import { Button } from './ui/button';

export const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const isActivePath = (path) => {
    return location.pathname === path;
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white border-b border-gray-200">
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center group">
            <img 
              src="https://customer-assets.emergentagent.com/job_2343b8d4-bf7c-477c-9f5a-ad0017c87460/artifacts/jta8nfui_IMG_1207.jpeg" 
              alt="Top Driver Driving School" 
              className="h-24 w-auto transform group-hover:scale-105 transition-transform duration-200"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            {mockData.navigation.map((item) => {
              const isHighlight = item.highlight;
              const isActive = isActivePath(item.path);
              
              let linkClasses = 'text-sm font-medium transition-colors duration-200 relative group ';
              if (isHighlight) {
                linkClasses += 'text-green-600 hover:text-green-700 font-bold';
              } else if (isActive) {
                linkClasses += 'text-red-600';
              } else {
                linkClasses += 'text-gray-700 hover:text-red-600';
              }
              
              return (
                <Link
                  key={item.name}
                  to={item.path}
                  className={linkClasses}
                >
                  {isHighlight && <span className="mr-1">💰</span>}
                  {item.name}
                  <span
                    className={`absolute -bottom-1 left-0 w-full h-0.5 ${isHighlight ? 'bg-green-600' : 'bg-red-600'} transform origin-left transition-transform duration-200 ${
                      isActive
                        ? 'scale-x-100'
                        : 'scale-x-0 group-hover:scale-x-100'
                    }`}
                  />
                </Link>
              );
            })}
          </div>

          {/* CTA Button */}
          <div className="hidden md:block">
            <Button
              asChild
              className="bg-red-600 hover:bg-red-700 text-white px-6 transition-colors duration-200"
            >
              <Link to="/contact">Book a Lesson</Link>
            </Button>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors duration-200"
          >
            {mobileMenuOpen ? (
              <X className="w-6 h-6 text-black" />
            ) : (
              <Menu className="w-6 h-6 text-black" />
            )}
          </button>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-200 bg-white">
            <div className="flex flex-col space-y-4">
              {mockData.navigation.map((item) => {
                const isHighlight = item.highlight;
                const isActive = isActivePath(item.path);
                
                let linkClasses = 'text-sm font-medium px-4 py-2 rounded-lg transition-colors duration-200 ';
                if (isHighlight) {
                  linkClasses += 'text-green-600 bg-green-50 font-bold';
                } else if (isActive) {
                  linkClasses += 'text-red-600 bg-red-50';
                } else {
                  linkClasses += 'text-gray-700 hover:bg-gray-50';
                }
                
                return (
                  <Link
                    key={item.name}
                    to={item.path}
                    onClick={() => setMobileMenuOpen(false)}
                    className={linkClasses}
                  >
                    {isHighlight && <span className="mr-1">💰</span>}
                    {item.name}
                  </Link>
                );
              })}
              <div className="px-4">
                <Button
                  asChild
                  className="w-full bg-red-600 hover:bg-red-700 text-white transition-colors duration-200"
                >
                  <Link to="/contact" onClick={() => setMobileMenuOpen(false)}>
                    Book a Lesson
                  </Link>
                </Button>
              </div>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};